import { render, staticRenderFns } from "./TableWs.vue?vue&type=template&id=ee823ac8&scoped=true"
import script from "./TableWs.vue?vue&type=script&lang=js"
export * from "./TableWs.vue?vue&type=script&lang=js"
import style0 from "./TableWs.vue?vue&type=style&index=0&id=ee823ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee823ac8",
  null
  
)

export default component.exports